import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import {
    completePromises,
    saveRequestForm,
} from "./downstream-backend-calls";
import downstreamValidation from "./downstream-validation";

let _projectSelection;
const STATUSES = {
    PENDING_SUBMISSION: '1',
    SUBMITTED_FOR_PROCESSING: '2',
    REJECTED: '3',
    SUBMITTED_FOR_REVIEW: '4',
    APPROVED: '5',
    PENDING_SIGNATURES: '6',
    LEGAL_REVIEW_REQUIRED: '7',
    FULLY_EXECUTED: '8',
    PREQUALIFYING_SUBCONTRACTOR: '9'
}
export default function () {
    const $entry = $('[name=Entry]');
    return new Promise((resolve, reject) => {
        if (!$entry.length) initializeDisplay();
        else initializeEntry();
        resolve();
    });
};

const initializeEntry = () => {
    initializeContractTypeDropdown();
    initializeProjectCostCodeDropdown();
    initializeTaxJurisdictionDropdown();
    attachContractTypeChangeEvent();
    attachExistingContractCheckboxEvent();
    attachIsTaxExemptCheckboxEvent();
    attachSaveRequestEvent();
    attachDeleteRequestEvent();
    initializeElementsShown();
    attachProjectSelectionEvent();
    attachWorkOrderSelectionEvent();
    initializeSubcontractDropdown();
    attachVendorSelectionEvent();
    attachShippingAddressSelection();
}

const initializeDisplay = () => {
    const contractType = $('[name="ContractType"]').data('value').toString();
    toggleSelectItems(contractType);
    attachRejectRequestEvent();
    attachSaveRequestEvent();
}

const initializeContractTypeDropdown = () => {
    const $contractTypeDropDown = $('select[name="ContractType"]');
    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');
    if (k_contractTypeDropDown) return;

    $contractTypeDropDown.kendoDropDownList({
        optionLabel: "",
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource:
            {
                transport: {
                    read: {
                        url: '/Operations/DownstreamContract/GetContractTypeOptions',
                    },
                    parameterMap: function (data, type) {
                        let rs = {};
                        if (type === 'read') {
                            return rs;
                        }
                    }
                }
            },
        dataBound(e) {
            toggleSelectItems(e.sender.value());
        }
    });
}

const initializeProjectCostCodeDropdown = () => {
    const $projectCostCodeDropDown = $('select[name="ProjectCostCode"]');
    const k_projectCostCodeDropDown = $projectCostCodeDropDown.data('kendoDropDownList');
    if (k_projectCostCodeDropDown) return;

    $projectCostCodeDropDown.kendoDropDownList({
        optionLabel: "",
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource:
            {
                transport: {
                    read: {
                        url: '/Operations/DownstreamContract/GetProjectCostCodeOptions',
                    },
                    parameterMap: function (data, type) {
                        let rs = {};
                        if (type === 'read') {
                            const k_projectSelection = $('[name="Project.FullName"]').data('kendoAutoComplete')
                            if (k_projectSelection) {
                                const selection = _projectSelection || k_projectSelection.value();
                                if (selection)
                                    rs.contract = selection.split('-')[0].trim();
                            }

                            rs.contractType = getContractType().toString();
                            rs.company = $('[name=Company]').val();
                            return rs;
                        }
                    }
                }
            },
        dataBound(args) {
            const value = $projectCostCodeDropDown.data('value').toString();
            const k_dropdown = $projectCostCodeDropDown.data('kendoDropDownList');
            const data = k_dropdown.dataSource.data();
            const selection = data.find(item => item.Value === value);
            if (selection) {
                const selectionIndex = data.indexOf(selection);
                k_dropdown.select(selectionIndex);
            }
        },
        filter: "contains"
    });
}

const initializeSubcontractDropdown = () => {
    const $contractTypeDropDown = $('select[name="ExistingContract"]');
    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');
    if (k_contractTypeDropDown) return;

    const isChecked = $('[name="IsForExistingContract"]').prop('checked');

    $contractTypeDropDown.kendoDropDownList({
        optionLabel: "",
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource:
            {
                transport: {
                    read: {
                        url: '/Operations/DownstreamContract/GetSubContractOptions',
                    },
                    parameterMap: function (data, type) {
                        let rs = {};
                        if (type === 'read') {
                            const k_projectSelection = $('[name="Project.FullName"]').data('kendoAutoComplete')
                            if (k_projectSelection) {
                                const selection = _projectSelection || k_projectSelection.value();
                                if (selection)
                                    rs.contract = selection.split('-')[0].trim();
                            }

                            const k_workOrderSelection = $('[name="WorkOrderNumber"]').data('kendoAutoComplete');
                            if (k_workOrderSelection) {
                                const selection = k_workOrderSelection.value();
                                if (selection) {
                                    rs.workOrder = selection.split('-')[0].trim();
                                }
                            }

                            rs.contractType = getContractType();
                            rs.company = $('[name=Company]').val();
                            return rs;
                        }
                    }
                }
            },
        enable: isChecked,
        dataBound(args) {
            const value = $contractTypeDropDown.data('value').toString();
            const k_dropdown = $contractTypeDropDown.data('kendoDropDownList');
            const data = k_dropdown.dataSource.data();
            const selection = data.find(item => item.Value === value);
            if (selection) {
                const selectionIndex = data.indexOf(selection);
                k_dropdown.select(selectionIndex);
            }
        },
        filter: "contains"
    });
}

const initializeTaxJurisdictionDropdown = () => {
    const $taxJurisdictionsDropDown = $('select[name="TaxJurisdiction"]');
    const k_taxJurisdictionsDropDown = $taxJurisdictionsDropDown.data('kendoDropDownList');
    if (k_taxJurisdictionsDropDown) return;

    const isChecked = $('[name="IsProjectTaxExempt"]').prop('checked');

    $taxJurisdictionsDropDown.kendoDropDownList({
        optionLabel: "",
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource:
            {
                transport: {
                    read: {
                        url: '/Operations/DownstreamContract/GetTaxJurisdictionOptions',
                    },
                    parameterMap: function (data, type) {
                        let rs = {};
                        if (type === 'read') {
                            rs.company = $('[name=Company]').val();
                            return rs;
                        }
                    }
                }
            },
        enable: !isChecked,
        dataBound(args) {
            const value = $taxJurisdictionsDropDown.data('value').toString();
            const k_dropdown = $taxJurisdictionsDropDown.data('kendoDropDownList');
            selectDropdownValue(k_dropdown, value);
        }
    });
}

const selectDropdownValue = (k_dropdown, value) => {
    const data = k_dropdown.dataSource.data();
    let selection = data.find(item => item.Value === value);
    if (selection) {
        const selectionIndex = data.indexOf(selection);
        k_dropdown.select(selectionIndex);
    }
}

const getProjectTaxJurisdiction = () => {
    const $workOrder = $('[name=WorkOrderNumber]');
    const workOrderSelection = $workOrder.val();

    const data = {
        company: $('[name=Company]').val(),
        project: _projectSelection,
        workOrder: workOrderSelection.split("-")[0].trim()
    }

    const $taxJurisdictionsDropDown = $('select[name="TaxJurisdiction"]');

    $.post('/Operations/DownstreamContract/GetProjectTaxJurisdiction', data, (response) => {
        $taxJurisdictionsDropDown.data('value', response);
        const k_dropdown = $taxJurisdictionsDropDown.data('kendoDropDownList');
        selectDropdownValue(k_dropdown, response);
    });
}

const initializeElementsShown = () => {
    const $contractTypeDropDown = $('[name="ContractType"]');
    const contractTypeValue = $contractTypeDropDown.data('value');

    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');
    if (k_contractTypeDropDown) {
        k_contractTypeDropDown.value(contractTypeValue);
    }
    toggleSelectItems(contractTypeValue);
}

const attachContractTypeChangeEvent = () => {
    const $contractTypeDropDown = $('.js-dropdown-custom[name="ContractType"]');
    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');

    if (k_contractTypeDropDown) {
        k_contractTypeDropDown.bind('change', changeContractTypeEventHandler);
    }
}

const changeContractTypeEventHandler = (event) => {
    const value = event.sender.value();
    $(event.sender).data('value', value);
    toggleSelectItems(value);
    readProjectCostCode();
    readExistingContractDropDown();
}

const toggleSelectItems = (idToShow) => {
    const $items = $('[data-for-contract-type]');
    $.each($items, (index, element) => {
        const $element = $(element);
        const forContractType = $element.data('for-contract-type');
        const $elementParent = $element.parents('.form-item');

        const isForAll = forContractType.indexOf('ALL') !== -1;
        const isForSelection = forContractType.indexOf(idToShow) !== -1;

        if (idToShow && (isForAll || isForSelection)) $elementParent.show();
        else hideElement($elementParent);
    });
    shiftSubcontractInfoSection(idToShow);
    toggleSections(idToShow);

    $('.display-for-contract').hide();
    $(`.display-for-contract.contract-${idToShow}`).show();
    $('.required-for-contract').data('required', 'false').attr('data-required', 'false');
    $(`.required-for-contract.contract-${idToShow}`).data('required', 'true').attr('data-required', 'true');
}

const hideElement = (element) => {
    const $element = $(element);
    const $input = $element.find('input, select');

    if ($input.length) {
        if ($input.hasClass('k-textbox')) $input.val('');
        if ($input.hasClass('js-dropdown')) {
            const k_dropdownList = $input.data('kendoDropDownList');
            if (k_dropdownList) k_dropdownList.value('');
        }
    }

    $element.hide();
}

const shiftSubcontractInfoSection = (selectedValue) => {
    const $vendorInfoSection = $('[name=VendorInfoSection]')
    const $vendorShippingInfoSection = $('[name=VendorShippingInfoSection]')

    if (selectedValue === '4') {
        $vendorInfoSection.attr('data-flex-item', 'width: 12');
        $vendorShippingInfoSection.show();
    } else {
        $vendorInfoSection.attr('data-flex-item', 'width: 24');
        $vendorShippingInfoSection.hide();
    }
}

const toggleSections = (idToShow) => {
    const topics = $('.topic').not('#subcontract-setup');
    if (!idToShow) topics.hide();
    else topics.show();
}

const attachExistingContractCheckboxEvent = () => {
    const $checkbox = $('[name="IsForExistingContract"]');
    if ($checkbox.length) {
        $checkbox.bind('change', existingContractChange);
    }
}

const existingContractChange = (e) => {
    const k_existingContract = $('[name="ExistingContract"]').data('kendoDropDownList');
    if (!k_existingContract) return;
    const isChecked = $(e.currentTarget).prop('checked');
    k_existingContract.enable(isChecked);
    if (!isChecked) k_existingContract.select(0);
}

const attachIsTaxExemptCheckboxEvent = () => {
    const $checkbox = $('[name="IsProjectTaxExempt"]');
    if ($checkbox.length) {
        $checkbox.bind('change', projectTaxExemptChange);
    }
}

const projectTaxExemptChange = (e) => {
    const k_taxJurisdiction = $('[name="TaxJurisdiction"]').data('kendoDropDownList');
    if (!k_taxJurisdiction) return;
    const isChecked = $(e.currentTarget).prop('checked');
    k_taxJurisdiction.enable(!isChecked);
    if (isChecked) k_taxJurisdiction.select(0);

    $('.js-tax-jurisdiction-text').toggle(isChecked)
}

const attachSaveRequestEvent = () => {
    const $saveButton = $('#saveButton');
    $saveButton.bind('click', saveDownstreamContract)
}

const saveDownstreamContract = () => {
    const $saveButton = $('#saveButton');
    $saveButton.prop('disabled', true);
    const currentStatus = $('[name=Status]').val();
    const $statusSelection = $('select.js-status-selector').data('kendoDropDownList');
    const statusSelection = $statusSelection ? $statusSelection.value() : currentStatus;

    if (currentStatus < STATUSES.SUBMITTED_FOR_PROCESSING && statusSelection > STATUSES.PENDING_SUBMISSION && !downstreamValidation()) {
        $saveButton.prop('disabled', false);
        return;
    }

    let hasStatusChanged = currentStatus !== statusSelection;

    if (shouldSaveFormData(currentStatus, statusSelection)) {
        let serializedData = $('form').serialize();
        serializedData += `&Status=${statusSelection}`
        saveRequestForm(serializedData)
            .then(_ => completePromises(currentStatus, statusSelection))
            .then(response => showSuccessNotification(response))
            .then(_ => {
                if (statusSelection === STATUSES.SUBMITTED_FOR_PROCESSING || hasStatusChanged) {
                    window.location.href = getRedirectLink(hasStatusChanged, $('[name="Id"]').val());
                }
            })
            .catch(error => showErrorNotification(error))
            .finally(_ => {
                $saveButton.prop('disabled', false);
            });
    } else {
        completePromises(currentStatus, statusSelection)
            .then(response => showSuccessNotification(response))
            .then(_ => {
                if (statusSelection === STATUSES.REJECTED || statusSelection === STATUSES.FULLY_EXECUTED || hasStatusChanged) {
                    window.location.href = getRedirectLink(hasStatusChanged, $('[name="Id"]').val());
                }
            })
            .catch(error => showErrorNotification(error))
            .finally(_ => {
                $saveButton.prop('disabled', false);
            });
    }
}

const getRedirectLink = (hasStatusChanged, downstreamId = null) => {
    return '/Operations/DownstreamContract/RequestGrid';
}

const shouldSaveFormData = (currentStatus, statusSelection) => {
    if (currentStatus <= STATUSES.PENDING_SUBMISSION || currentStatus === STATUSES.REJECTED) return true;
    if (currentStatus > STATUSES.PENDING_SUBMISSION) return false;
    return statusSelection > STATUSES.PENDING_SUBMISSION;
}

const attachDeleteRequestEvent = () => {
    const $saveButton = $('.js-delete-request');
    $saveButton.bind('click', deleteRequestForm);
}

const deleteRequestForm = () => {
    const id = $('[name=Id]').val();
    if (id <= 0) {
        window.location.href = getRedirectLink(true);
        return;
    }

    $.post(`/Operations/DownstreamContract/DeleteDownstreamContractRequest?id=${id}`, function (response) {
        if (response.success) {
            $('[name="Id"]').val(response.id);
            showSuccessNotification(response.message);
            window.location.href = getRedirectLink(true);
        } else {
            showErrorNotification(response.message);
        }
    })
}

const attachRejectRequestEvent = () => {
    //Deprecated
    const $saveButton = $('button[data-role=reject]');
    $saveButton.bind('click', rejectRequestForm)
}

const rejectRequestForm = () => {
    //Deprecated
    const $rejectionComments = $('[name=rejection_comment]');
    const rejectionComments = $rejectionComments.val();
    if (rejectionComments === '') {
        showErrorNotification('Comments are required for rejection');
        return;
    }

    let data = {
        id: $('[name=Id]').val(),
        rejectionComments: rejectionComments
    };

    $.post('/Operations/DownstreamContract/RejectDownstreamContractRequest', data, (response) => {
        if (response.success) {
            showSuccessNotification(response.message);
            window.location.href = getRedirectLink(true);
        } else {
            showErrorNotification(response.message);
        }
    })
}

const attachProjectSelectionEvent = () => {
    const $projectAutocomplete = $('input.js-project-autocomplete');
    const k_projectAutocomplete = $projectAutocomplete.data('kendoAutoComplete');

    if (k_projectAutocomplete)
        k_projectAutocomplete.bind('change', projectSelectionEvent);
}

const projectSelectionEvent = (e) => {
    const projectSelected = e.sender.value();
    const projectNumber = projectSelected.substr(0, 8);

    _projectSelection = projectNumber;

    getProjectTaxJurisdiction();
    readExistingContractDropDown();
    readProjectCostCode();
    getProjectAccountant(projectNumber);
    getProjectManager(projectNumber);
    isProjectCertified(projectNumber);
    $('.js-dropdown[name=ShippingAddressSelect]').trigger('change');
}

const attachWorkOrderSelectionEvent = () => {
    const $workOrderAutocomplete = $('input.js-work-order-autocomplete');
    const k_workOrderAutocomplete = $workOrderAutocomplete.data('kendoAutoComplete');

    if (k_workOrderAutocomplete)
        k_workOrderAutocomplete.bind('change', workOrderSelectionEvent);
}

const workOrderSelectionEvent = () => {
    readExistingContractDropDown();
    getProjectTaxJurisdiction();
}
const readExistingContractDropDown = () => {
    const k_existingContract = $('[name="ExistingContract"]').data('kendoDropDownList');

    if (k_existingContract)
        k_existingContract.dataSource.read();
}

const readProjectCostCode = () => {
    const k_projectCostCodeDropdown = $('[name="ProjectCostCode"]').data('kendoDropDownList');

    if (k_projectCostCodeDropdown)
        k_projectCostCodeDropdown.dataSource.read();
}

const getProjectAccountant = (project) => {
    $.post(`/Operations/DownstreamContract/GetProjectAccountant?project=${project}`, (response) => {
        const k_projectAccountantAutoComplete = $('[name="ProjectAccountant.DisplayName"]').data('kendoAutoComplete');

        if (k_projectAccountantAutoComplete && response !== '') {
            const autoCompleteValue = k_projectAccountantAutoComplete.dataSource.data().find(item => {
                return item.toLowerCase().includes(response.toLowerCase());
            })

            k_projectAccountantAutoComplete.value(autoCompleteValue || response);
        }
    })
}

const getProjectManager = (project) => {
    $.post(`/Operations/DownstreamContract/GetProjectManager?project=${project}`, (response) => {
        const k_projectManagerAutoComplete = $('[name="ProjectManager.DisplayName"]').data('kendoAutoComplete');

        if (k_projectManagerAutoComplete && response !== '') {
            const autoCompleteValue = k_projectManagerAutoComplete.dataSource.data().find(item => {
                return item.toLowerCase().includes(response.toLowerCase());
            })

            k_projectManagerAutoComplete.value(autoCompleteValue || response);
        }
    })
}

const isProjectCertified = (project) => {
    $.post(`/Operations/DownstreamContract/IsPayrollCertified?project=${project}`, (response) => {
        if (response) {
            $('[name="IsCertifiedPayrollRequired"]span.k-icon.k-i-error.k-icon-md.--red-dark').removeClass('--red-dark').removeClass('k-i-error').addClass('k-i-check-outline').addClass('--green');
            return;
        }

        $('[name="IsCertifiedPayrollRequired"]span.k-icon.k-i-check-outline.k-icon-md.--green').removeClass('k-i-check-outline').removeClass('--green').addClass('--red-dark').addClass('k-i-error');
    })
}

const attachVendorSelectionEvent = () => {
    const $vendorAutoComplete = $('input.js-vendor-dropdown');
    const k_vendorAutoComplete = $vendorAutoComplete.data('kendoDropDownList');

    if (k_vendorAutoComplete)
        k_vendorAutoComplete.bind('select', vendorSelection);
}

const toggleBondRequiredMessage = (vendorSelected) => {
    const k_projectSelection = $('[name="Project.FullName"]').data('kendoAutoComplete');
    let contract = '';
    if (k_projectSelection) {
        const selection = _projectSelection || k_projectSelection.value();
        if (selection)
            contract = selection.split('-')[0].trim();
    }

    let data = {
        company: $('[name=Company]').val(),
        contract: contract,
        contractType: getContractType().toString(),
        vendor: vendorSelected.Number
    }

    $.post('/Operations/DownstreamContract/IsBondRequiredForVendor', data, (response) => {
        $('[name="SubcontractorRequiresBond"]').toggle(response)
    });
}

const populateVendorAddress = (vendorSelected) => {
    $('[name="SubcontractorVendorNumber"]').val(vendorSelected.Number);
    $('[name="SubcontractorVendorContactName"]').val(vendorSelected.ContactName);
    $('[name="SubcontractorVendorPhoneNumber"]').val(vendorSelected.Phone);
    $('[name="SubcontractorVendorEmail"]').val(vendorSelected.Email);

    const address = vendorSelected.Address;
    if (address == null) return;
    $('[name="Address.StreetAddress"]').val(address.StreetAddress);
    $('[name="Address.City"]').val(address.City);
    $('[name="Address.State"]').val(address.State);
    $('[name="Address.PostalCode"]').val(address.PostalCode);
}

const vendorSelection = (e) => {
    const vendorSelected = e.dataItem;
    if (vendorSelected == null) return;
    $('input[name=SubcontractorVendorName]').val(vendorSelected.Name);
    populateVendorAddress(vendorSelected);
    toggleBondRequiredMessage(vendorSelected);
}

const attachShippingAddressSelection = () => {
    const $shippingDropDown = $('.js-dropdown[name=ShippingAddressSelect]');
    if (!$shippingDropDown.length) return;

    $shippingDropDown.bind('change', shippingAddressChanged);

    const value = $shippingDropDown.data('value').toString();
    const k_dropdown = $shippingDropDown.data('kendoDropDownList');
    const data = k_dropdown.dataSource.data();
    const selection = data.find(item => item.value === value);
    if (selection) {
        const selectionIndex = data.indexOf(selection);
        k_dropdown.select(selectionIndex);
    }
}

const shippingAddressChanged = (e) => {
    const k_projectSelection = $('[name="Project.FullName"]').data('kendoAutoComplete')
    const data = {
        company: $('[name="Company"]').val(),
        contract: _projectSelection || k_projectSelection.value(),
        type: $(e.currentTarget).val()
    }
    if (!data.contract) return;

    const $streetAddress = $('[name="ShippingAddress.StreetAddress"]');
    const $city = $('[name="ShippingAddress.City"]');
    const $state = $('[name="ShippingAddress.State"]');
    const $postalCode = $('[name="ShippingAddress.PostalCode"]');

    const isCustomerPickup = data.type === 'C';
    $streetAddress.prop('disabled', isCustomerPickup);
    $city.prop('disabled', isCustomerPickup);
    $state.prop('disabled', isCustomerPickup);
    $postalCode.prop('disabled', isCustomerPickup);

    if (data.type !== 'J' && data.type !== 'S' && data.type !== 'D') {
        $streetAddress.val("");
        $city.val("");
        $state.val("");
        $postalCode.val("");
        return;
    }

    $.post('/Operations/DownstreamContract/GetVendorShippingAddress', data, (response) => {
        if (response == null) return;
        $('[name="ShippingAddress.StreetAddress"]').val(response.StreetAddress);
        $('[name="ShippingAddress.City"]').val(response.City);
        $('[name="ShippingAddress.State"]').val(response.State);
        $('[name="ShippingAddress.PostalCode"]').val(response.PostalCode);
    })
}

const getContractType = () => {
    const $contractTypeDropDown = $('[name="ContractType"]');
    const k_contractTypeDropDown = $contractTypeDropDown.data('kendoDropDownList');

    return Number(k_contractTypeDropDown.value()) || Number($contractTypeDropDown.data('value')) || -1;
}
